import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { OtherEquivalancyUnitsDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/other-data/equivalancy-units/equivalancy-units-data-grid.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'piqet-angular-new-equivalancy-units',
  templateUrl: './new-equivalancy-units.component.html',
  styleUrls: ['./new-equivalancy-units.component.scss'],
})
export class NewEquivalancyUnitsComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  equivalancyUnitsData: any;
  equivalancyUnitsAddEditForm!: FormGroup;
  imageInfoForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  selectOrganization: any;
  organizationlist: any;
  indicatorList: any;
  selectedFiles: any;
  activeCheckbox = false;
  fileToUpload: any;
  imageUrl: any;
  fileBase64: any;
  imagePreview = '';
  isImageValid = true;
  isDisableDropDown!: boolean;
  lastFieldFrom: any;
  base64: any = [];
  selectedMultipleFiles: any = [];
  @Output() saveNewEquivalancyUnitsEvent = new EventEmitter<any>();
  imageSizeMax: boolean = false;
  showEdit: boolean = false;
  showCreate: boolean = false;
  showView: boolean = false;
  checkEntireAccess: boolean = false;
  fromEdit: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private otherEquivalancyUnitsDataGridService: OtherEquivalancyUnitsDataGridService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.equivalancyUnitsData =
      this.modal?.modalService?.config?.initialState?.['newEquivalancyUnitsData'];
    this.isDisableDropDown =
      this.modalLabel == 'Edit organization equivalency units' ? true : false;
    this.organizationlist = this.equivalancyUnitsData.organizationList;
    this.indicatorList = cloneDeep(this.equivalancyUnitsData.indicatiorList);
    this.organizatioListFunction();
  }

  ngOnInit(): void {
    this.showEdit = this.otherEquivalancyUnitsDataGridService.isAccess(this.activatedRoute, 'edit');
    this.showCreate = this.otherEquivalancyUnitsDataGridService.isAccess(
      this.activatedRoute,
      'create'
    );
    this.showView = this.otherEquivalancyUnitsDataGridService.isAccess(this.activatedRoute, 'view');
    this.checkEntireAccess =
      (this.showCreate && !this.fromEdit) ||
      (this.fromEdit && this.showEdit) ||
      (this.fromEdit && !this.showView);
    const form = [];
    const formSecond = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      const name: any = 'name' + i;
      form[this.indicatorList[i].name] = new FormControl(
        this.equivalancyUnitsData.indicatiorList[i].name || 0,
        Validators.required
      );
    }
    for (let i = 0; i < this.indicatorList.length; i++) {
      formSecond[this.indicatorList[i].name] = new FormControl(
        this.equivalancyUnitsData.indicatiorList[i].multiplier || 0,
        Validators.required
      );
    }
    this.imageInfoForm = new FormGroup(form);
    this.lastFieldFrom = new FormGroup(formSecond);
    this.equivalancyUnitsAddEditForm = this.formBuilder.group({
      organizationName: [
        this.equivalancyUnitsData.organizationId || this.organizationlist[0] || null,
      ],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.equivalancyUnitsData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  setFormData() {
    this.equivalancyUnitsAddEditForm.patchValue({ organizationName: this.selectOrganization });
  }

  fileChangeEvent(fileData: any, event: any) {
    this.imageSizeMax = false;
    this.imageInfoForm.value;
    const reader = new FileReader(); // HTML5 FileReader API
    this.selectedFiles = event.target.files[0].name;
    fileData.selectedFiles = event.target.files[0].name;
    this.imagePreview = '';
    const file = event.target.files[0];
    const mimeType = file?.type;
    const maxSizeMB = 4;

    if (file.size > maxSizeMB * 1024 * 1024) {
      this.imageSizeMax = true;
      return;
    } else {
      this.imageSizeMax = false;
    }
    if (mimeType?.match(/image\/*/) == null) {
      this.imagePreview = '';
      this.isImageValid = false;
      return;
    } else {
      this.imagePreview = '';
      this.isImageValid = true;
      if (event.target.files && event.target.files[0]) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imageUrl = reader.result;
          fileData.imageUrl = reader.result;
          this.fileBase64 = this.imageUrl.split(',')[1];
          this.base64.push({ filename: this.fileBase64, id: fileData.indicatorId });
          this.selectedMultipleFiles.push({
            filename: this.selectedFiles,
            id: fileData.indicatorId,
          });
        };
      }
    }
  }

  removeImage(formData: any, hiddenfileinput: any) {
    formData.selectedFiles = '';
    this.selectedMultipleFiles.map((x: any) => {
      if (x.id == formData.indicatorId) {
        x.filename = formData.selectedFiles;
      }
    });
    hiddenfileinput.value = null;
    this.imageSizeMax = false;
  }

  onSave() {
    this.submitted = true;
    if (!this.isImageValid || !this.imageInfoForm.valid || this.imageSizeMax) {
      return;
    }

    if (!this.lastFieldFrom.valid) {
      return;
    }
    const entires = Object.entries(this.imageInfoForm.value);
    const entiresSecond = Object.entries(this.lastFieldFrom.value);
    const arrayObj = entiresSecond.map(item => {
      return {
        fieldName: item[0],
        fieldNameValue: item[1],
      };
    });
    const resultArray: any = [];
    let i = {};
    const entiresArray = this.equivalancyUnitsData.indicatiorList.map((obj: any, index: any) => ({
      ...obj,
      ...entires[index],
    }));
    const arr3 = entiresArray.map((item: any, i: any) => Object.assign({}, item, arrayObj[i]));
    arr3.forEach((event: any, index: any) => {
      i = {
        indicatorId: event.indicatorId,
        name: event[1],
        unit: event.unit,
        defaultValue: event.defaultValue,
        equivalencyUnits: event[1],
        multiplier: Number(event.fieldNameValue),
        EquivalencyPictureFileName:
          this.selectedMultipleFiles.find((x: any) => x.id == event.indicatorId)?.filename || '',
        EquivalencyImage: '',
        EquivalencyPictureFile:
          this.base64.find((x: any) => x.id == event.indicatorId)?.filename || '',
      };
      resultArray.push(i);
    });
    const conversionPayload = {
      id: this.equivalancyUnitsData.id,
      organizationId: this.equivalancyUnitsData.organizationId,
      indicatiorList: resultArray,
    };
    this.saveNewEquivalancyUnitsEvent.emit(conversionPayload);
  }
}
